import React from 'react';
import Typography from '@material-ui/core/Typography';
import displayText from './displayText.json';

function GlobalPpsiDiscontinueText() {
  return (
    <div>
      <Typography style={{ color: '#FF0000', marginRight: '20px' }}>
        {displayText.globalPpsiDiscontinueText}
      </Typography>
    </div>
  );
}

export default GlobalPpsiDiscontinueText;
